import { Box, Typography } from "@mui/material";
import ReactHtmlParser from "@/src/utils/html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleAcknowledgments = ({
  acknowledgments,
}: {
  acknowledgments: string[];
}) => (
  <Box component="section" role="doc-acknowledgments">
    <Typography
      component="h2"
      color="primary"
      sx={{
        display: "flex",
        alignItems: "center"
      }}>
      <SpanTypography sx={{
        fontSize: HEADING_SIZE.section
      }}>Acknowledgments</SpanTypography>
    </Typography>
    <Box component="aside">
      {acknowledgments.map((content: string, index: number) => (
        <Typography key={`acknowledgment-${index}`}>
          {ReactHtmlParser(content)}
        </Typography>
      ))}
    </Box>
  </Box>
);

export default ArticleAcknowledgments;
